document.addEventListener('DOMContentLoaded', () => {
  // Accordion functionality
  const headers = document.querySelectorAll('.accordion-header');

  headers.forEach((header) => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const isActive = content.classList.contains('active');
      const allContents = document.querySelectorAll('.accordion-content');
      const allHeaders = document.querySelectorAll('.accordion-header');

      // Close all sections
      allContents.forEach((c) => c.classList.remove('active'));
      allHeaders.forEach((h) => h.classList.remove('active'));

      // Open the clicked section if it wasn't already open
      if (!isActive) {
        content.classList.add('active');
        header.classList.add('active');
      }
    });
  });

  // Subscribe option default selection with 1-second delay
  setTimeout(() => {
    const subscribeOption = document.querySelector(
      'input[data-selling-plan-id="3940614237"]'
    );
    if (subscribeOption) {
      subscribeOption.checked = true;

      const clickEvent = new Event('click', { bubbles: true });
      subscribeOption.dispatchEvent(clickEvent);

      const changeEvent = new Event('change', { bubbles: true });
      subscribeOption.dispatchEvent(changeEvent);
    }
  }, 1000);
});
document.addEventListener('DOMContentLoaded', () => {
  function updatePriceByProductURL(
    productURLContains,
    discountPercent = 11.83
  ) {
    const links = document.querySelectorAll(
      '.card__information a.full-unstyled-link'
    );

    links.forEach((link) => {
      if (link.href.includes(productURLContains)) {
        const card = link.closest('.card__information');
        if (!card) return;

        const regularPriceSpan = card.querySelector(
          '.price__regular .price-item--regular'
        );
        if (!regularPriceSpan || regularPriceSpan.dataset.discounted === 'true')
          return;

        const priceText = regularPriceSpan.textContent.trim();
        const match = priceText.match(/\$([\d.]+)\s*(.*)/); // captures price and suffix

        if (!match) return;

        const originalPrice = parseFloat(match[1]);
        const suffix = match[2] || ''; // whatever was after the number

        const discountedPrice = (
          originalPrice *
          (1 - discountPercent / 100)
        ).toFixed(2);
        regularPriceSpan.textContent = `$${discountedPrice} ${suffix}`.trim();
        regularPriceSpan.dataset.discounted = 'true';
      }
    });
  }

  updatePriceByProductURL(
    'rosemary-and-nz-harakeke-oil-for-hair-and-eyebrows-subscription-1'
  );

  const observer = new MutationObserver(() => {
    updatePriceByProductURL(
      'rosemary-and-nz-harakeke-oil-for-hair-and-eyebrows-subscription-1'
    );
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

function checkForDateElements() {
  const dateElements = document.querySelectorAll('.yotpo-date-format');
  const dateRegex = /^(\d{2})\/(\d{2})\/(\d{2})$/;

  if (dateElements.length > 0) {
    let dayOffset = 2; // Start with a 2-day reduction for the first date

    dateElements.forEach((element) => {
      const originalDate = element.textContent.trim();
      if (dateRegex.test(originalDate)) {
        // Extract day, month, year from the matched date
        const [_, day, month, year] = originalDate.match(dateRegex);

        // Parse the date components
        const dayNum = parseInt(day, 10);
        const monthNum = parseInt(month, 10);
        const fullYear = 2000 + parseInt(year, 10); // Assuming YY is 20YY

        // Create a Date object
        const date = new Date(fullYear, monthNum - 1, dayNum);

        // Subtract the day offset
        date.setDate(date.getDate() - dayOffset);

        // Format the new date as DD/MM/YYYY
        const newDay = String(date.getDate()).padStart(2, '0');
        const newMonth = String(date.getMonth() + 1).padStart(2, '0');
        const newYear = date.getFullYear();
        element.textContent = `${newDay}/${newMonth}/${newYear}`;

        // Increase the offset by 2 for the next date
        dayOffset += 2;
      }
    });
  } else {
    // Check again after 500ms if no elements are found
    setTimeout(checkForDateElements, 500);
  }
}

// Start polling after DOM is loaded
document.addEventListener('DOMContentLoaded', checkForDateElements);

document
  .querySelectorAll('.loading-spinner, .loader')
  .forEach((el) => (el.style.display = 'none'));
